import styled, { css } from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding: 0 1rem;
`;

export const DefaultButton = styled.button`
  border: 0;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  padding: 1rem 1.2rem;
  background-color: #505061;
  cursor: ${props => props.$isClosing ? 'not-allowed' : 'pointer'};
  color: #fff;

  ${({ accessLevel }) =>
    accessLevel?.includes('ACESSIBILIDADE') &&
    css`
      background-color: #000000 !important;
      color: #ffffff !important;
      border: 3px solid #000000 !important;
    `}

  opacity: ${props => props.$isClosing ? 0.5 : 1};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: ${props => props.$isClosing ? 0.5 : 0.9};
  }

  &:disabled {
    pointer-events: ${props => props.$isClosing ? 'none' : 'auto'};
  }
`;

export const Off = styled.button`
  border: 0;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  min-width: 80px;
  padding: 1rem 1.75rem;
  background-color: #dc362e;
  cursor: ${props => props.$isClosing ? 'not-allowed' : 'pointer'};
  color: #fff;

  ${({ accessLevel }) =>
    accessLevel?.includes('ACESSIBILIDADE') &&
    css`
      background-color: #000000 !important;
      color: #ffffff !important;
      border: 3px solid #000000 !important;
    `}

  opacity: ${props => props.$isClosing ? 0.5 : 1};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: ${props => props.$isClosing ? 0.5 : 0.9};
  }

  &:disabled {
    pointer-events: ${props => props.$isClosing ? 'none' : 'auto'};
  }
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const LoadingSpinner = styled.div`
  > div {
    font-size: 4px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: relative;
    text-indent: -9999em;
    animation: mulShdSpinRed 1.1s infinite ease;
    transform: translateZ(0);
    margin: 0.5rem;

    @keyframes mulShdSpinRed {
      0%,
      100% {
        box-shadow: 0em -2.6em 0em 0em #ffffff,
          1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
          2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
          1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
          0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
          -2.6em 0em 0 0em rgba(255, 255, 255, 0.5),
          -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.7);
      }
      12.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.7),
          1.8em -1.8em 0 0em #ffffff, 2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
          1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
          0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
          -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.5);
      }
      25% {
        box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.5),
          1.8em -1.8em 0 0em rgba(255, 255, 255, 0.7), 2.5em 0em 0 0em #ffffff,
          1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
          0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
          -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
      }
      37.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
          1.8em -1.8em 0 0em rgba(255, 255, 255, 0.5),
          2.5em 0em 0 0em rgba(255, 255, 255, 0.7), 1.75em 1.75em 0 0em #ffffff,
          0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
          -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
      }
      50% {
        box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
          1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
          2.5em 0em 0 0em rgba(255, 255, 255, 0.5),
          1.75em 1.75em 0 0em rgba(255, 255, 255, 0.7), 0em 2.5em 0 0em #ffffff,
          -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.2),
          -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
      }
      62.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
          1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
          2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
          1.75em 1.75em 0 0em rgba(255, 255, 255, 0.5),
          0em 2.5em 0 0em rgba(255, 255, 255, 0.7), -1.8em 1.8em 0 0em #ffffff,
          -2.6em 0em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
      }
      75% {
        box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
          1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
          2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
          1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
          0em 2.5em 0 0em rgba(255, 255, 255, 0.5),
          -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.7), -2.6em 0em 0 0em #ffffff,
          -1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2);
      }
      87.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(255, 255, 255, 0.2),
          1.8em -1.8em 0 0em rgba(255, 255, 255, 0.2),
          2.5em 0em 0 0em rgba(255, 255, 255, 0.2),
          1.75em 1.75em 0 0em rgba(255, 255, 255, 0.2),
          0em 2.5em 0 0em rgba(255, 255, 255, 0.2),
          -1.8em 1.8em 0 0em rgba(255, 255, 255, 0.5),
          -2.6em 0em 0 0em rgba(255, 255, 255, 0.7), -1.8em -1.8em 0 0em #ffffff;
      }
    }
  }
`;